import React, { useEffect, FC } from "react";
import { Paper, Grid, Container, Theme, SxProps } from "@mui/material";
import PageWithLoad from "../progress/PageWithLoad";

interface IProps {
  children: any;
  fullWidth?: boolean;
  isModal?: boolean;
  isLoading?: boolean;
}

const SingleColLayout: FC<IProps> = (props) => {
  const { children, fullWidth, isModal, isLoading } = props;

  useEffect(() => {
    sessionStorage.removeItem("readonly");
  }, []);

  const containerProps: SxProps<Theme> | undefined = fullWidth
    ? {
        maxWidth: { xs: "100%", md: "100%", lg: "100%", xl: "100%" },
      }
    : {
        maxWidth: { xs: "100%", md: "90%", lg: "75%", xl: "70%" },
      };

  return (
    <>
      <PageWithLoad loading={isLoading ?? false}>
        <Container sx={containerProps}>
          <Grid container spacing={isModal ? 1 : 3}>
            <Grid item xs={12}>
              {!isModal ? <Paper variant="paper">{children}</Paper> : children}
            </Grid>
          </Grid>
        </Container>
      </PageWithLoad>
    </>
  );
};

export default SingleColLayout;
